import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Component, Inject } from '@angular/core';

@Component({
  selector: 'app-message',
  templateUrl: './app-message.component.html',
  styleUrls: ['./app-message.component.css']
})
export class AppMessageComponent {

  constructor(public dialogRef: MatDialogRef<AppMessageComponent>,
              @Inject(MAT_DIALOG_DATA) public data:any) {    
  }
}